var Backbone = require('backbone');
var _ = require('underscore');

var Service = require('front/pages/Service/Service');
var Objects = require('front/components/Objects/Objects');
var SellBlockInfo = require('front/components/SellBlockInfo/SellBlockInfo');
var Discount = require('front/components/Discount/Discount');
var Feedbacks = require('front/components/Feedbacks/Feedbacks');

module.exports = Service.extend({
    template: require('./ServiceCommonPopup.jinja'),

    el: '.ServiceCommonPopup',

    initialize: function (options) {
        Service.prototype.initialize.call(this, options);

        if (options.server) {
            this.data = {
                feedbacks: window.app.data.feedbacks,
                objects: window.app.data.objects
            };
        }

        this.apiUrl = options.apiUrl;
    },

    render: function () {
        Service.prototype.render.call(this);
    },

    viewsRegistration: function () {
        this.registerView('objects', new Objects({
            objects: this.data.objects
        }));
        this.registerView('sellBlockInfo', new SellBlockInfo());
        this.registerView('discount', new Discount());
        this.registerView('feedbacks', new Feedbacks({
            feedbacks: this.data.feedbacks
        }));
    },

    playIn: function () {
        this.$el.hide();

        return new Promise(function (resolve) {
            this.$el.fadeIn(function () {
                resolve();
            });
        }.bind(this));
    },

    playOut: function () {
        return new Promise(function (resolve) {
            this.$el.fadeOut(function () {
                resolve();
            });
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/ServiceCommon/ServiceCommonPopup.js
// module id = 8
// module chunks = 0